import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, Outlet } from 'react-router-dom';
import { HeaderPresenter } from '/src/presenters/HeaderPresenter';


/**
 * Lysnnar på användarens currentUser i userSlice och skyddar child routes. om användaren
 * inte är inloggad (dvs currentUser är tom), navigerar den till login-sidan.
 */
export function ProtectedLayout() {
  const navigate = useNavigate();
  const currentUser = useSelector(state => state.user.currentUser);
  const status = useSelector(state => state.user.status);

  useEffect(() => {
    // Om användaren loggar ut, navigera till login
    if (!currentUser) {
      navigate('/', { replace: true });  // replace: true undviker att fylla history
    }
  }, [currentUser, navigate]);

  // Rendera child routes via Outlet
  return (
    <>
      <HeaderPresenter /> {/* Rendera header på alla pages om man är inloggad */}
      <main>
        <Outlet />
      </main>
    </>
  );
}